import { render, staticRenderFns } from "./codeAdmin.vue?vue&type=template&id=b7d2ac4e&scoped=true&"
import script from "./codeAdmin.vue?vue&type=script&lang=js&"
export * from "./codeAdmin.vue?vue&type=script&lang=js&"
import style0 from "./codeAdmin.vue?vue&type=style&index=0&id=b7d2ac4e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7d2ac4e",
  null
  
)

export default component.exports